import hatsApi from '@/services/hatsApi'
import _ from 'lodash'
import store from '@/store'

export default {
  setDefaultServiceAttributes (params) {
    // Price type is required, but we don't have this option during record creation
    if (typeof params.priceTypeId === 'undefined' && typeof params.priceType === 'undefined') {
      params.priceTypeId = 1
    }
  },
  setRelations (params) {
    if ((typeof params.serviceType !== 'undefined' && params.serviceType !== null && params.serviceType.id) && !params.serviceTypeId) {
      params.serviceTypeId = params.serviceType.id
    }
    if ((typeof params.country !== 'undefined' && params.country !== null && params.country.id) && !params.countryId) {
      params.countryId = params.country.id
    }
    if ((typeof params.serviceCategory !== 'undefined' && params.serviceCategory !== null && params.serviceCategory.id) && !params.serviceCategoryId) {
      params.serviceCategoryId = params.serviceCategory.id
    }
    if ((typeof params.priceType !== 'undefined' && params.priceType !== null && params.priceType.id) && !params.priceTypeId) {
      params.priceTypeId = params.priceType.id
    }
  },
  modifyCollections (params) {
    if (typeof params.seasons !== 'undefined' && params.seasons.length) {
      _.forEach(params.seasons, (item) => {
        if (item.new) {
          delete item.id
        }
      })
    }
    if (typeof params.priceRules !== 'undefined' && params.priceRules.length) {
      let discountCalcType = _.find(store.getters.calcTypes, {'code': 'DISCOUNT'})
      _.forEach(params.priceRules, (item) => {
        if (item.new) {
          delete item.id
        }
        // Always set calc type to discount if price rule type is alternate nights
        if (item.priceRuleType.code === 'ALTERNATENIGHTS' || item.priceRuleType === '3') {
          if (discountCalcType) {
            item.priceRuleCalcType = discountCalcType
          }
        }
        // Last minute does not have min
        if (item.priceRuleType.code === 'LASTMINUTE' || item.priceRuleType === '12') {
          item.min = null
        }
        // Early booked does not have max
        if (item.priceRuleType.code === 'BOOKDATE' || item.priceRuleType === '5') {
          item.max = null
        }
        // Fix the id
        if (!isNaN(item.priceRuleType)) {
          item.priceRuleTypeId = item.priceRuleType
          delete item.priceRuleType
        }
        if (!isNaN(item.priceRuleCalcType)) {
          item.priceRuleCalcTypeId = item.priceRuleCalcType
          delete item.priceRuleCalcType
        }
      })
    }
    if (typeof params.childServiceLinks !== 'undefined' && params.childServiceLinks.length) {
      _.forEach(params.childServiceLinks, (item) => {
        if (item.new) {
          delete item.id
        }
      })
    }
    if (typeof params.transportTimePeriods !== 'undefined' && params.transportTimePeriods.length) {
      _.forEach(params.transportTimePeriods, (item) => {
        if (item.new) {
          delete item.id
        }
        _.forEach(item.transportTimes, (time) => {
          if (time.new) {
            delete time.id
          }
        })
      })
    }
    if (typeof params.basePrices !== 'undefined' && params.basePrices.length) {
      _.forEach(params.basePrices, (item) => {
        if (item.new) {
          delete item.id
        }
        if (!item.hasOwnProperty('arrivalDays') || item.arrivalDays === '0000000') {
          item.arrivalDays = '1111111'
        }
      })
    }
  },
  childServiceLinksOrdering (params) {
    if (typeof params.childServiceLinks !== 'undefined' && params.childServiceLinks.length) {
      let primaryOrder = 1
      let nonPrimaryOrder = 1
      _.forEach(params.childServiceLinks, (item) => {
        if (item.primary) {
          item.order = primaryOrder
          item.primary = 1
          primaryOrder++
        } else {
          item.order = nonPrimaryOrder
          item.primary = 0
          nonPrimaryOrder++
        }
      })
    }
  },
  getServiceTypes (params) {
    let filter = params || ''
    return hatsApi().get('/system/service-type/?filter=' + JSON.stringify(filter))
  },
  getServiceCategories (params) {
    let filter = params || ''
    return hatsApi().get('/system/service-category/?filter=' + JSON.stringify(filter))
  },
  createService (params) {
    this.setDefaultServiceAttributes(params)
    this.setRelations(params)
    return hatsApi().post('/master-data/service', params)
  },
  updateService (params) {
    this.setRelations(params)
    this.modifyCollections(params)
    this.childServiceLinksOrdering(params)
    return hatsApi().put('/master-data/service/' + params.id, params)
  },
  getService (id) {
    return hatsApi().get('/master-data/service/' + id)
  },
  getServices (params, limit, p, reservationId) {
    let filter = params || ''
    let pageSize = limit || ''
    let page = p || ''
    let pagination = ''

    if (pageSize) {
      pagination += '&pageSize=' + pageSize
    }

    if (page) {
      pagination += '&page=' + page
    }

    if (reservationId) {
      pagination += '&reservation_id=' + reservationId
    }

    return hatsApi().get('/master-data/service/?filter=' + JSON.stringify(filter) + pagination)
  },
  createServiceLink (params) {
    return hatsApi().post('/master-data/service-link', params)
  },
  getBasePrices (params) {
    return hatsApi().get('/master-data/base-price?filter=' + JSON.stringify(params))
  },
  getServiceLinks (params) {
    let filter = params || ''
    return hatsApi().get('/master-data/service-link/?filter=' + JSON.stringify(filter))
  },
  exportTransferList (id, params) {
    let filter = params || ''
    return hatsApi().get('/master-data/service/transfer-list/' + id + filter, {'responseType': 'blob'})
  },
  clearCache (id) {
    return hatsApi().get('/master-data/service/cache-clear/' + id)
  },
  copyTrip (id) {
    return hatsApi().get('/master-data/service/copy-trip/' + id)
  }
}



// WEBPACK FOOTER //
// ./src/services/hatsApi/Service.js